import styled from 'styled-components';

export const IconWrapper = styled.div`
  position: relative;
  svg {
    fill: ${({ theme }) => theme.colors.title};
    stroke: ${({ theme }) => theme.colors.title};
  }
`;

export const Actions = styled.div`
  width: max-content;
  position: absolute;
  right: 30px;
  bottom: -10px;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 12px;
  box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.themeColor};

  .action {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;

    &:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    }
  }

  & svg {
    fill: none;
    stroke: ${({ theme }) => theme.colors.title};
  }
`;
